const recommendStoreToastMsg = {
  /**
   *  추천 브랜드 리스트 요청하기
   */
  GET_RECOMMEND_STORE_LIST_REQUEST_SUCCESS: '추천 브랜드 리스트 요청하기 성공',
  GET_RECOMMEND_STORE_LIST_REQUEST_ERROR: '추천 브랜드 리스트 요청하기 실패',

  /**
   *  추천 브랜드 상세 요청하기
   */
  GET_RECOMMEND_STORE_DETAIL_REQUEST_SUCCESS: '추천 브랜드 상세 요청하기 성공',
  GET_RECOMMEND_STORE_DETAIL_REQUEST_ERROR: '추천 브랜드 상세 요청하기 실패',

  /**
   *  추천 브랜드 복사하기 전 필요한 데이터 요청하기
   */
  PREPARE_COPY_RECOMMEND_STORE_REQUEST_SUCCESS: '추천 브랜드 복사하기 전 필요한 데이터 요청하기 성공',
  PREPARE_COPY_RECOMMEND_STORE_REQUEST_ERROR: '추천 브랜드 복사하기 전 필요한 데이터 요청하기 실패',

  /**
   *  추천 브랜드 등록하기 전 필요한 데이터 요청하기
   */
  PREPARE_CREATE_RECOMMEND_STORE_REQUEST_SUCCESS: '추천 브랜드 등록하기 전 필요한 데이터 요청하기 성공',
  PREPARE_CREATE_RECOMMEND_STORE_REQUEST_ERROR: '추천 브랜드 등록하기 전 필요한 데이터 요청하기 실패',

  /**
   *  추천 브랜드에 연결할 아이템 리스트 요청하기
   */
  GET_RECOMMEND_STORE_ITEM_REQUEST_SUCCESS: '추천 브랜드에 연결할 아이템 리스트 요청하기 성공',
  GET_RECOMMEND_STORE_ITEM_REQUEST_ERROR: '추천 브랜드에 연결할 아이템 리스트 요청하기 실패',

  /**
   *  추천 브랜드 등록/복사하기
   */
  CREATE_RECOMMEND_STORE_REQUEST_SUCCESS: '추천 브랜드 등록/복사하기 성공',
  CREATE_RECOMMEND_STORE_REQUEST_ERROR: '추천 브랜드 등록/복사하기 실패',

  /**
   *  전체 브랜드 리스트 EXCEL 다운로드
   */
  GET_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '전체 브랜드 리스트 EXCEL 다운로드 성공',
  GET_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '전체 브랜드 리스트 EXCEL 다운로드 실패',

  /**
   *  선택된 브랜드 리스트 EXCEL 다운로드
   */
  GET_SELECTED_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '선택된 브랜드 리스트 EXCEL 다운로드 성공',
  GET_SELECTED_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '선택된 브랜드 리스트 EXCEL 다운로드 실패',

  /**
   *  브랜드 리스트 EXCEL 업로드
   */
  SET_RECOMMEND_STORE_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS: '브랜드 리스트 EXCEL 업로드 성공',
  SET_RECOMMEND_STORE_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR: '브랜드 리스트 EXCEL 업로드 실패',
};

export default recommendStoreToastMsg;
